import { digestHex, signHex } from './crypto.js';
import { sealAddress } from './sealed.js';
import type { RequestBody, SignedRequest, UserRequest } from './types.js';

/**
 * A withdraw request body with the address sealed to the sequencer and bound
 * to the withdrawing account. Keep `salt` to prove the destination later.
 */
export function withdrawBody(encKey: string, zat: string, address: string, user: string, salt?: string) {
  const sealed = sealAddress(encKey, address, user, salt);
  return { body: { type: 'withdraw' as const, zat, enc: sealed.enc, commit: sealed.commit }, salt: sealed.salt, commit: sealed.commit };
}

/** Build and sign a request for the log `chain` (its Ledger.chainId). Used by the web wallet, bots and tests. */
export function signRequest(secretKey: string, user: string, nonce: number, body: RequestBody, chain: string, ts = Date.now()): SignedRequest {
  const req: UserRequest = { v: 1, chain, user, nonce, ts, body };
  return { req, sig: signHex(digestHex('request', req), secretKey) };
}
